/*

	 * Main JS file
	To use Ajax with vanilla JS, you can use the Fetch API or Axios. (Axios is too heavy)
	https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
*/


import { MainSmooth } from './src/main-smooth';

const app = new MainSmooth({
	is_ajax: true,
	domain: 'audramanzano.com',
	debug: document.location.hostname !== 'audramanzano.com',
	slide_transition: false,
	time_fade_in: 0.2, //0.17,
	time_fade_out: 0.1, //0.1,
	project_name: "Last",
	$scroll_el: '#smooth-scroll',
	is_lenis: true,
	scrollTo0AfterPageLoad: true,

	//GA_MEASUREMENT_ID 	: 'G-9TYL5NPZ8Y',

	redirects: [
		//['/work/', '/work/filter/featured/'],
		//['/about/', '/about/profile/']
	]

});

app.init();
